import { render, staticRenderFns } from "./MealDetail.vue?vue&type=template&id=f6a82ba4&"
import script from "./MealDetail.vue?vue&type=script&lang=js&"
export * from "./MealDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports